import React from "react";
import { BannerContainer } from "./styles"; // Importa o estilo do Banner

const Banner: React.FC = () => {
  return <BannerContainer />; // Renderiza o Banner com os estilos aplicados
};

export default Banner;
